import React, { useContext } from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Typography from '@material-ui/core/Typography'
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Avatar,
} from '@material-ui/core'
import { ICircle, IMember } from 'daily-dose-common'
import circleDefaultImage from '../../assets/images/circle.png'
import {
  SearchIcon,
  AddIcon,
  GroupAddIcon,
  HistoryIcon,
  EditIcon,
} from '../../assets/icons'
import { FirestoreContext } from '../../providers/firestore-provider'
import AvatarGroup from '@material-ui/lab/AvatarGroup'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
    },
    media: {
      height: 250,
    },
    membersContainer: {
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
      display: 'flex',
      justifyContent: 'space-between',
    },
    options: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    button: {
      margin: theme.spacing(1, 0, 1, 1),
    },
    avatarsContainer: {
      cursor: 'pointer',
    },
  })
)

interface IMyCircleDetailsItemProps {
  circle: ICircle
  onGoToAddDose: () => void
  onGoToAddAMember: () => void
  onGoToEditCircle: () => void
  onGoToMembers: () => void
  onGoToPastDoses: () => void
  onGoToTodaysDose: () => void
}

export const MyCircleDetailsItem = ({
  circle,
  onGoToAddDose,
  onGoToAddAMember,
  onGoToEditCircle,
  onGoToMembers,
  onGoToPastDoses,
  onGoToTodaysDose,
}: IMyCircleDetailsItemProps) => {
  const classes = useStyles()
  const { currentUser } = useContext(FirestoreContext)
  const isCircleOwner = () => currentUser?.id === circle.creatorId
  const pictureBelongsToUser = (member: IMember) => currentUser?.id === member.id
  // TODO: Fix auto refresh by updating circle data here instead of Google Cloud Functions incrementCommentCount
  return (
    <Paper style={{ overflow: 'auto' }}>
      <Card className={classes.root}>
        <CardMedia
          className={classes.media}
          image={circle.photoURL || circleDefaultImage}
          title={circle.name}
        />
        <CardContent>
          <Box className={classes.membersContainer}>
            <AvatarGroup
              max={5}
              className={classes.avatarsContainer}
              onClick={onGoToMembers}
            >
              {circle.members.map((member, i) => (
                <Avatar
                  key={i}
                  alt={member.displayName || member.username}
                  src={
                    (pictureBelongsToUser(member) && currentUser?.photoURL) ||
                    member.photoURL
                  }
                >
                  {member.displayName?.charAt(0)?.toUpperCase()}
                </Avatar>
              ))}
            </AvatarGroup>
            <Button
              style={{ textTransform: 'none' }}
              variant="contained"
              color="primary"
              size="small"
              className={classes.button}
              startIcon={<GroupAddIcon />}
              onClick={onGoToAddAMember}
            >
              Invite
            </Button>
          </Box>
          <Typography gutterBottom variant="h5" component="h2">
            {circle.name}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {circle.description}
          </Typography>
          <List
            component="ul"
            aria-labelledby="nested-list-subheader"
            className={classes.options}
          >
            <ListItem button disableGutters onClick={onGoToTodaysDose}>
              <ListItemIcon>
                <SearchIcon />
              </ListItemIcon>
              <ListItemText primary="Today's dose" />
            </ListItem>
            <ListItem button disableGutters onClick={onGoToAddDose}>
              <ListItemIcon>
                <AddIcon />
              </ListItemIcon>
              <ListItemText primary="Add a dose" />
            </ListItem>
            <ListItem button disableGutters onClick={onGoToPastDoses}>
              <ListItemIcon>
                <HistoryIcon />
              </ListItemIcon>
              <ListItemText primary="Past doses" />
            </ListItem>
            {isCircleOwner() && (
              <ListItem button disableGutters onClick={onGoToEditCircle}>
                <ListItemIcon>
                  <EditIcon />
                </ListItemIcon>
                <ListItemText primary="Edit group" />
              </ListItem>
            )}
            {/* // TODO: To be implemented */}
            {/* <ListItem button onClick={handleClick} disableGutters>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Settings" />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  className={classes.nested}
                  onClick={() => alert('Go to privacy. To be implemented')}
                >
                  <ListItemIcon>
                    <LockIcon />
                  </ListItemIcon>
                  <ListItemText primary="Privacy" />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  onClick={() => alert('Go to date validity. To be implemented')}
                >
                  <ListItemIcon>
                    <DateRangeIcon />
                  </ListItemIcon>
                  <ListItemText primary="Validity" />
                </ListItem>
                <ListItem
                  button
                  className={classes.nested}
                  onClick={() => alert('Leave the group. To be implemented')}
                >
                  <ListItemIcon>
                    <ExitToAppIcon />
                  </ListItemIcon>
                  <ListItemText primary="Leave circle" />
                </ListItem>
              </List>
            </Collapse> */}
            <ListItem disableGutters>
              <Typography variant="subtitle2" color="textSecondary">
                {`Available doses: ${circle.totalAvailableDoses}`}
              </Typography>
            </ListItem>
          </List>
        </CardContent>
      </Card>
    </Paper>
  )
}
